(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("AvgByHourReportViewModel", avgByHourReportViewModelFactory);

  /** @ngInject */
  function avgByHourReportViewModelFactory(
    reportActions,
    reportsFilterStore,
    dispatcher,
    ActionTypesEnum
  ) {
    function AvgByHourReportViewModel() {
      this._reportsFilterStoreChangeHandler = null;
      this.chart = {
        data: null,
        x: {
          tick: {
            culling: { max: 15 },
            rotate: 60
          }
        }
      };

      init.call(this);
    }

    AvgByHourReportViewModel.prototype.destroy = function () {
      reportsFilterStore.off(
        reportsFilterStore.events.CHANGE,
        this._reportsFilterStoreChangeHandler
      );
    };

    return AvgByHourReportViewModel;

    function init() {
      var that = this;
      this.isChartVisible = false;

      searchByFilter.call(that);
      this._reportsFilterStoreChangeHandler = function () {
        searchByFilter.call(that);
      };

      reportsFilterStore.on(
        reportsFilterStore.events.CHANGE,
        this._reportsFilterStoreChangeHandler
      );
    }

    function searchByFilter() {
      var that = this,
        reportFilterData = reportsFilterStore.getFilterData();

      reportActions
        .getAvgByHours(
          "",
          reportFilterData.fromTimestamp,
          reportFilterData.toTimestamp,
          reportFilterData.currency
        )
        .then(function (successData) {
          that.chart.data = successData;
          that.isChartVisible = successData.total !== 0 ? true : false;
          dispatcher.dispatch({
            type: ActionTypesEnum.HIDE_LOADER
          });
        });
    }
  }
})();
